import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { SessionFacade } from '../session/session.facade';
import { CookieService } from 'ngx-cookie-service';

const SAML_LOGOUT_URL = '/saml/logout';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private session: SessionFacade, private cookieService: CookieService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((returnedError: HttpErrorResponse) => {
                console.error('Error: ', returnedError);
                const { error, status } = returnedError;
                const isUnexpectedHtmlResponse =
                    error.error instanceof Error && status === 200 && error.error?.message.includes('Unexpected token');
                // status 0 is the browser's generic "no response information" signal - it covers a
                // blocked cross-origin redirect, but also any other transient network failure.
                const hasNoServerResponse = status === 0;
                if (isUnexpectedHtmlResponse || hasNoServerResponse) {
                    this.session.clear();
                    this.cookieService.delete('WAIT-FOR-LEGACY-BOOTSTRAPING');
                    window.location.replace(SAML_LOGOUT_URL);
                } else {
                    this.handleServerSideError(returnedError);
                }
                return throwError(() => returnedError);
            })
        );
    }

    private handleServerSideError(error: HttpErrorResponse): void {
        switch (error.status) {
            case 401:
                this.session.clear();
                window.location.replace(SAML_LOGOUT_URL);
                break;
            case 403:
                this.session.clear();
                break;
        }
    }
}
